import { useEffect, useState } from "react";
import usePWAInstall from "../usePWAInstall";

const InstallPromptComponent = () => {
    const { installAvailable, promptInstall } = usePWAInstall();
    const [showTile, setShowTile] = useState(false);
    const [showSafariGuide, setShowSafariGuide] = useState(false);

    const isSafari = () => {
        const ua = navigator.userAgent;
        return /Safari/.test(ua) && !/Chrome|CriOS|FxiOS|EdgiOS/.test(ua);
    };

    useEffect(() => {
        // Check if already installed (localStorage for Safari, appinstalled handled by hook)
        const alreadyInstalled = localStorage.getItem("pwaInstalled");
        if (alreadyInstalled) return;

        if (installAvailable) {
            setShowTile(true);
        } else if (isSafari() && !localStorage.getItem("pwaInstalled")) {
            // Force show tile on Safari if not installed yet
            setShowTile(true);
        }

    }, [installAvailable]);

    const handleInstallClick = async () => {
        console.log("Click called");
        console.log(isSafari());
        setShowTile(false);

        if (isSafari()) {
            // on safari show guide instead of promptInstall
            setShowSafariGuide(true);
        } else {
            const accepted = await promptInstall();
            if (accepted) {
                // Mark installed after successful Chrome/Edge install
                localStorage.setItem("pwaInstalled", "true");
            }
        }
    };

    const handleCancelClick = () => {
        setShowTile(false);
        // mark dismissed so it doesn’t reappear
        localStorage.setItem("pwaInstalled", "false");
    };

    // if (!installAvailable && !showTile) return null;

    if (!installAvailable && !showTile && !(isSafari() && !localStorage.getItem("pwaInstalled"))) {
        return null;
    }


    return (
        <>
            {/* Bottom tile */}
            <div
                style={{
                    position: "fixed",
                    bottom: showTile ? "20px" : "-120px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "#fff",
                    color: "#000",
                    border: "1px solid #ddd",
                    borderRadius: "12px",
                    padding: "16px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "90%",
                    maxWidth: "500px",
                    zIndex: 1000,
                    transition: "bottom 0.3s ease-in-out",
                }}
            >
                <div>
                    <h4 style={{ margin: "0 0 6px 0" }}>Enhance Your Experience</h4>
                    <p style={{ margin: 0, fontSize: "14px", color: "#555" }}>
                        Install our PWA for a faster, full-screen experience.
                    </p>
                </div>
                <div style={{ marginLeft: "12px", whiteSpace: "nowrap" }}>
                    <button
                        onClick={handleCancelClick}
                        style={{
                            marginRight: "12px",
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            color: "#666",
                        }}
                    >
                        Later
                    </button>
                    <button
                        onClick={handleInstallClick}
                        style={{
                            backgroundColor: "#121B33",
                            color: "white",
                            border: "none",
                            borderRadius: "6px",
                            padding: "6px 12px",
                            cursor: "pointer",
                        }}
                    >
                        Install
                    </button>
                </div>
            </div>

            {/* Safari custom install guide */}
            {showSafariGuide && (
                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(0,0,0,0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 2000,
                    }}
                    onClick={() => setShowSafariGuide(false)}
                >
                    <div
                        style={{
                            background: "#fff",
                            borderRadius: "12px",
                            padding: "20px",
                            maxWidth: "400px",
                            textAlign: "center",
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h3>How to Install on Safari</h3>
                        <p style={{ fontSize: "14px", color: "#444" }}>
                            Tap the <strong>Share</strong> button in Safari, then select{" "}
                            <strong>Add to Home Screen</strong>.
                        </p>
                        <img
                            src="./pwa-guide.gif"
                            alt="Safari Install Guide"
                            style={{
                                height: "240px",
                                borderRadius: "8px",
                                margin: "10px auto",
                                display: "block"
                            }}
                        />
                        <div style={{ marginTop: "1rem" }}>
                            <button

                                onClick={() => {
                                    setShowSafariGuide(false);
                                    localStorage.setItem("pwaInstalled", "true");
                                }}
                                style={{
                                    backgroundColor: "#121B33",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "6px",
                                    padding: "6px 12px",
                                    cursor: "pointer",
                                }}
                            >
                                Got It
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default InstallPromptComponent;
